(() => {
  const imageMagnificationStates = new WeakMap();

  function magnify(image, event, zoomRatio) {
    const previous = imageMagnificationStates.get(image);
    if (previous) {
      previous.close();
      return;
    }
    if (!image.isConnected || !image.parentElement) return;

    const container = image.parentElement;
    const spinner = image.closest('.product__modal-opener')?.querySelector('.loading__spinner');
    const originalOpacity = image.style.opacity;
    const spinnerWasHidden = spinner?.classList.contains('hidden');
    const overlay = document.createElement('div');
    const fullSizeImage = document.createElement('img');
    let finished = false;
    let lastPointer = event;
    let timeout;

    overlay.className = 'image-magnify-full-size';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.style.backgroundColor = 'var(--gradient-background)';

    const restoreLoadingState = () => {
      image.style.opacity = originalOpacity;
      if (spinner) spinner.classList.toggle('hidden', spinnerWasHidden);
    };

    const close = () => {
      finished = true;
      clearTimeout(timeout);
      fullSizeImage.onload = null;
      fullSizeImage.onerror = null;
      overlay.remove();
      restoreLoadingState();
      container.removeEventListener('mousemove', move);
      container.removeEventListener('mouseleave', close);
      document.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('resize', close);
      imageMagnificationStates.delete(image);
    };

    const move = (pointer) => {
      lastPointer = pointer;
      const bounds = image.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;
      const x = Math.min(100, Math.max(0, ((pointer.clientX - bounds.left) / bounds.width) * 100));
      const y = Math.min(100, Math.max(0, ((pointer.clientY - bounds.top) / bounds.height) * 100));
      overlay.style.backgroundPosition = `${x}% ${y}%`;
      overlay.style.backgroundSize = `${bounds.width * zoomRatio}px`;
    };

    const onKeyDown = (keyEvent) => {
      if (keyEvent.key === 'Escape') close();
    };

    imageMagnificationStates.set(image, { close });
    overlay.addEventListener('click', close);
    container.addEventListener('mousemove', move);
    container.addEventListener('mouseleave', close);
    document.addEventListener('keydown', onKeyDown);
    window.addEventListener('resize', close);
    image.style.opacity = '0.5';
    spinner?.classList.remove('hidden');

    // Register handlers before setting src so cached images cannot miss the load event.
    fullSizeImage.onload = () => {
      if (finished) return;
      if (!image.isConnected || image.parentElement !== container) {
        close();
        return;
      }
      clearTimeout(timeout);
      fullSizeImage.onload = null;
      fullSizeImage.onerror = null;
      overlay.style.backgroundImage = `url(${JSON.stringify(fullSizeImage.src)})`;
      container.insertBefore(overlay, image);
      restoreLoadingState();
      move(lastPointer);
    };
    fullSizeImage.onerror = close;
    timeout = setTimeout(close, 15000);
    fullSizeImage.src = image.src;
    if (fullSizeImage.complete) {
      if (fullSizeImage.naturalWidth) fullSizeImage.onload?.();
      else close();
    }
  }

  window.enableZoomOnHover = (zoomRatio) => {
    document.querySelectorAll('.image-magnify-hover').forEach((image) => {
      image.onclick = (event) => {
        // Touch and narrow screens use the accessible product media modal instead.
        if (!window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches) return;
        magnify(image, event, zoomRatio);
      };
    });
  };

  window.enableZoomOnHover(2);
})();
